import { BKJThemeColorType } from '@awais4123/fillify-design-library';
import { ActivityEventEnum } from 'types/graphql';

export const getActivityColorByStatus = (status: ActivityEventEnum): BKJThemeColorType => {
  switch (status) {
    case 'pending':
      return 'ShiftPending';
    case 'swap_expired':
    case 'swapped':
    case 'swap_initiated':
      return 'ShiftSwapped';
    case 'send_to_agencies':
    case 'sent_to_bookjane':
    case 'accepted_by_bookjane':
    case 'bidding_end':
    case 'placed_bid':
    case 'callout_list_created':
    case 'created':
    case 'requested':
      return 'ShiftRequested';
    case 'declined':
      return 'SecondaryPendingHover';
    case 'assigned':
      return 'ShiftAssigned';
    case 'accepted':
    case 'awarded_shift':
      return 'ShiftAccepted';
    case 'cancelled':
      return 'ShiftCancelled';
    case 'customer_released':
    case 'jane_released':
    case 'auto_released':
      return 'Grey6';
    default:
      return 'Grey6';
  }
};

// awarded_shift event.name
// ActivityTabRow.props.context.tsx:56 bidding_end event.name
// ActivityTabRow.props.context.tsx:56 placed_bid event.name
